import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { SITE, PEAK_BODIES } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer data-testid={FOOTER.root} className="bg-[#053043] text-[#E5E7EB] mt-24">
      <div className="ccdr-container py-16 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
        {/* Brand block */}
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="inline-flex items-center justify-center w-14 h-14 bg-white rounded-full shadow-sm">
              <img
                src="/ccdr-logo.png"
                alt="CCDR logo"
                className="w-12 h-12 object-contain"
                width="48"
                height="48"
              />
            </span>
            <span className="text-white text-lg">
              {SITE.name}
            </span>
          </div>
          <p className="max-w-md text-[#CBD5E1] leading-relaxed">
            An independent centre translating the global frameworks, standards, and innovations of climate and
            disaster resilience for leaders worldwide.
          </p>
          <p className="mt-6 text-sm text-[#9CB0C2]">
            For briefings, partnership proposals, and media requests, please visit our{" "}
            <Link
              to="/get-involved"
              className="text-[#E9C46A] hover:text-white border-b border-[#E9C46A]"
            >
              Get Involved page
            </Link>
            .
          </p>
        </div>

        {/* Nav */}
        <div className="lg:col-span-4 grid grid-cols-2 gap-8">
          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] text-[#D4A373] mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/focus-areas" className="hover:text-white">Focus Areas</Link></li>
              <li><Link to="/ethical-ai" className="hover:text-white">Responsible AI and Data</Link></li>
              <li><Link to="/frameworks" className="hover:text-white">Standards and Assurance</Link></li>
              <li><Link to="/insights" className="hover:text-white">Open Data Sources</Link></li>
              <li><Link to="/foresight" className="hover:text-white">Foresight Observatory</Link></li>
              <li><Link to="/media" className="hover:text-white">Media</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.22em] text-[#D4A373] mb-4">
              Engage
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/sdgs" className="hover:text-white">SDGs</Link></li>
              <li><Link to="/partnerships" className="hover:text-white">Partnerships</Link></li>
              <li><Link to="/resources" className="hover:text-white">Resources</Link></li>
              <li><Link to="/executive-education" className="hover:text-white">Executive Education</Link></li>
              <li><Link to="/get-involved" className="hover:text-white">Get Involved</Link></li>
            </ul>
          </div>
        </div>

        {/* Peak bodies */}
        <div className="lg:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.22em] text-[#D4A373] mb-4">
            References
          </h4>
          <p className="text-sm text-[#CBD5E1] mb-4 leading-relaxed">
            The Centre references these bodies as authoritative sources; presence here does not imply endorsement.
          </p>
          <ul className="flex flex-wrap gap-x-3 gap-y-2 text-xs text-[#9CB0C2]">
            {PEAK_BODIES.map((b) => (
              <li key={b.short} className="border border-[#1A6B8F] px-2 py-1">{b.short}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1A6B8F]">
        <div className="ccdr-container py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#9CB0C2]">
          <p>© {year} {SITE.name}.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/accessibility" className="hover:text-white">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
